export const refundMethods = [
  {
    label: 'Transferencia bancaria',
    value: 'bank_transfer',
  },
  {
    label: 'Crédito en tienda',
    value: 'store_credit',
  },
  {
    label: 'Método de pago original',
    value: 'original_payment_method',
  },
  {
    label: 'Tarjeta regalo',
    value: 'gift_card',
  },
]
